module.exports = __webpack_public_path__ + "static/media/tie.7d1f60e5.svg";